import './problem.css';

function Problem() {
  return (
    <section className="section problem">
      <div className="container">
        <div className="problem__card">
          <span className="section-label">¿Te pasa?</span>
          <h2 className="section-title">
            ¿Querés limpiar bien sin llenar tu casa de olores fuertes, envases descartables y productos que no sabés cómo usar?
          </h2>
          <p className="section-subtitle" style={{ maxWidth: 'none' }}>
            Entre tantas opciones del supermercado, es difícil saber qué comprar. Gastás plata en muchos productos cuando
            con pocos y bien elegidos alcanza. Además, los envases de un solo uso se acumulan y los químicos agresivos
            no son buenos para tu casa ni para el planeta.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Problem;
